export const AUTH_BASE_KEY = 'auth'
export const AUTH_PATH = '/auth'
